import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/field-templates/{fieldTemplateKey}/responses']['GET'];
type Input = ThisApi['params'];

const getQuestionnaireResponseByTemplateKey = async ({
  questionnaireId,
  fieldTemplateKey,
}: Input): Promise<ThisApi['response']> => {
  const path = `/questionnaires/${questionnaireId}/field-templates/${fieldTemplateKey}/responses`;
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getQuestionnaireResponseByTemplateKey;
